import { render, staticRenderFns } from "./CourseDetailsTab.vue?vue&type=template&id=2b5b3922&scoped=true&"
import script from "./CourseDetailsTab.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b3922",
  null
  
)

export default component.exports